import { withRouter } from "next/router";
import { useEffect, useState } from "react";
import { GET, POST } from "../../utils/requests";
import OptionView from "../shared/option";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { Feature } from "../shared/common";
import { MdOutlineDelete } from "react-icons/md";
import { HiMinusSm } from "react-icons/hi";
import { SubmitButton } from "../shared/input";
const PickupLocations = ({ router }) => {
  const [data, setData] = useState();
  useEffect(() => {
    if (router.query.pickup) Fetch();
  }, [router.query]);
  const Fetch = async () =>
    setData(
      await GET("/cart/pickups/" + router.query.pickup + "/" + router.query.cId)
    );

  return (
    <OptionView size="md" router={router} loading={!data} property="pickup">
      {!data ? null : data.map((s) => <Pickup cId={router.query.cId} {...s} />)}
    </OptionView>
  );
};

const Pickup = ({ address, pickup, cId }) => {
  const { location, id, name, stock, street, landMark, agentId } = address;

  const [prevQuantity, setPrevQuantity] = useState(pickup?.quantity || 0);
  const [quantity, setQuantity = s] = useState(pickup?.quantity || 0);

  useEffect(() => {
    setQuantity(pickup?.quantity || 0);
    setPrevQuantity(pickup?.quantity || 0);
  }, [pickup?.quantity]);

  useEffect(() => {
    if (prevQuantity !== quantity) Update();
  }, [quantity]);

  const Update = async () => {
    const x = await POST("/cart/UpdatePickups", {
      id: cId,
      addressId: id,
      quantity,
      pickupId: pickup?.id,
    });
    if (x?.status === false) setQuantity(prevQuantity);
    else setPrevQuantity(quantity);
  };

  return (
    <div className="pb-3 mb-3 border-bottom">
      <>
        <div className="flex-between">
          <h1 className="font-e-lg fw-bold mb-1">
            {name}
            {agentId ? (
              <span className="font-sm text-info fw-bold ms-2">Agent</span>
            ) : null}
          </h1>
          <div role="button" onClick={(_) => setQuantity(quantity ? 0 : 1)}>
            <BsFillCheckCircleFill
              className={`fs-5 ${quantity ? "text-success" : ""}`}
            />
          </div>
        </div>

        <p className="font-md mb-2">
          {street}, {landMark}, {location?.city}, {location?.stateCode}{" "}
          <span className="fw-600 text-blue">{location?.zipcode}</span>
        </p>
        <div className="flex-between">
          <Feature>
            <h4 className="font-sm mb-0">Qty :</h4>
            <div className="d-flex align-items-center ms-2">
              <SubmitButton
                title={
                  quantity !== 1 ? (
                    <HiMinusSm />
                  ) : (
                    <MdOutlineDelete className="text-danger" />
                  )
                }
                disabled={quantity < 1}
                onClick={(e) => setQuantity(quantity - 1)}
                variant="transparent p-0 mt-0 mb-0"
                color="danger"
              />
              <span className="fw-bold px-2 font-lg">{quantity}</span>
              <SubmitButton
                title={"+"}
                disabled={quantity >= stock}
                onClick={(e) => setQuantity(quantity + 1)}
                variant="transparent p-0 mt-0 mb-0"
                color="danger"
              />
            </div>
          </Feature>
          <Feature className="ms-3">
            <p className="mb-0 font-sm">
              Max{" "}
              <strong className="fw-bold text-danger font-md">{stock}</strong>
            </p>
          </Feature>
        </div>
      </>
    </div>
  );
};

export default withRouter(PickupLocations);
